import { ReactElement } from 'react'

import { Flex } from 'components/core'
import { ResourceLink } from 'components/Links/ResourceLink'
import { adGroupUrl } from 'routing/urls'

import { SelectedSearchTerm } from '../localTypes'
import * as styles from '../styles.scss'

interface Props {
    selectedSearchTerm: SelectedSearchTerm
}

const AdGroupLabel = ({
    selectedSearchTerm: {
        record: { ad_group, campaign },
    },
}: Props): ReactElement => (
    <Flex direction="column" alignItems="normal">
        <div className={styles.label}>Source Ad Group</div>
        <div className={styles.value}>
            <ResourceLink to={adGroupUrl(campaign.id, ad_group.id)}>
                {ad_group.name}
            </ResourceLink>
        </div>
    </Flex>
)

export default AdGroupLabel
